 import { useEffect, useRef, useState } from "react";
import "@/App.css";
import axios from "axios";
import emailjs from "@emailjs/browser";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EMAILJS_SERVICE_ID = "service_6rwnmp4";
const EMAILJS_TEMPLATE_ID = "template_rpfxarj";
const EMAILJS_PUBLIC_KEY = "90FrKV9Vs3pTF8L1u";


const PHONE_DIGITS = "919810069104";
const PHONE = "+919810069104";
const PHONE2 = "+919682390654";
const WHATSAPP_BASE = `https://wa.me/${PHONE_DIGITS}`;
const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/place/Al+Mubeen/@34.1149037,74.8846332,17z/data=!3m1!4b1!4m6!3m5!1s0x38e187591dba2649:0xdcf6eb32b3b9364f!8m2!3d34.1149037!4d74.8872081!16s%2Fg%2F11y9pttkh1";

// Elfsight Google Reviews — widget ID (script embed). Leave empty to use seeded reviews.
const GOOGLE_REVIEWS_WIDGET_ID = "7ae0da8a-95c0-4f89-97b5-fe8715b74095";

const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/jm0ousue_WhatsApp%20Image%202026-03-19%20at%2010.24.28%20PM.jpeg",
  exteriorMountain:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/zp8wywcs_%2C.png",
  rooftopSnow:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/aa2cwbdy_Screenshot%202026-03-23%20183236..png",
  bedroom:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/7bmgsqo6_WhatsApp%20Image%202026-03-23%20at%206.20.26%20PM.jpeg",
  living:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/a7cfhq8j_WhatsApp%20Image%202026-03-23%20at%206.19.50%20PM.jpeg",
  // Newly added real photos
  houseFront:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/01rc8b8q_WhatsApp%20Image%202026-05-25%20at%2010.39.45.jpeg",
  entryway:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/gth1goyz_WhatsApp%20Image%202026-05-25%20at%2017.12.59.jpeg",
  sittingRoom:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/b14rrxyy_WhatsApp%20Image%202026-05-25%20at%2017.15.08.jpeg",
  bedroom2:
    "https://customer-assets.emergentagent.com/job_site-maker-1086/artifacts/g5pfvj8k_WhatsApp%20Image%202026-05-25%20at%20rt.jpeg",
  // Curated Kashmir destination imagery
  dalLake:
    "https://images.unsplash.com/photo-1590060766060-c4af6c43961a?auto=format&fit=crop&w=1400&q=80",
  gulmarg:
    "https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?auto=format&fit=crop&w=1400&q=80",
  pahalgam:
    "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1400&q=80",
  sonmarg:
    "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1400&q=80",
  shikara:
    "https://i.ibb.co/5xxnvr64/2970152d-37e5-40dd-a242-258bef96ec53-q3ohmuwn1pa5bcufyqnkg3ycsc201tcqberc4an72g.jpg",
  garden:
    "https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=1400&q=80",
};

const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "rooms", label: "Rooms" },
  { id: "tours", label: "Tours" },
  { id: "gallery", label: "Gallery" },
  { id: "reviews", label: "Reviews" },
  { id: "contact", label: "Book" },
];

// Packages link is a standalone page, handled separately in Nav
const PACKAGES_URL = "packages.html";

const ROOMS = [
  {
    name: "🛏️ Double Room + Breakfast & Dinner",
    price: "₹2,000",
    unit: "per night",
    tag: "Best Value",
    subtitle: "Double Room • Breakfast & Dinner Included",
    desc: "Perfect for couples and solo travelers with home-cooked Kashmiri meals included.",
    image: ASSETS.bedroom,
    features: ["Comfortable Double Bed", "Breakfast Included", "Dinner Included", "Attached Bathroom", "Free Wi-Fi", "Hot & Cold Water", "Electric Blanket", "Housekeeping"],
    package: "Double Room + Breakfast & Dinner",
  },
  {
    name: "🛏️🛏️ Triple Room + Breakfast & Dinner",
    price: "₹2,800",
    unit: "per night",
    tag: "Most Popular",
    subtitle: "Triple Room • Breakfast & Dinner Included",
    desc: "Ideal for small groups and friends with home-cooked Kashmiri meals included.",
    image: ASSETS.sittingRoom,
    features: ["3 Beds", "Breakfast Included", "Dinner Included", "Attached Bathroom", "Free Wi-Fi", "Hot & Cold Water", "Electric Blanket", "Housekeeping"],
    package: "Triple Room + Breakfast & Dinner",
  },
  {
    name: "👨‍👩‍👧‍👦 Family Room + Breakfast & Dinner",
    price: "₹3,500",
    unit: "per night",
    tag: "Most Loved",
    subtitle: "2 Beds • Up to 4 Guests • Breakfast & Dinner Included",
    desc: "Spacious family room for up to 4 guests with home-cooked Kashmiri meals included.",
    image: ASSETS.living,
    features: ["2 Double Beds", "Up to 4 Guests", "Breakfast Included", "Dinner Included", "Attached Bathroom", "Free Wi-Fi", "Hot & Cold Water", "Electric Blanket", "Housekeeping"],
    package: "Family Room + Breakfast & Dinner",
  },
];

const TOURS = [
  {
    name: "Srinagar Weekend",
    badge: "🏷 Short Trip",
    image: "https://i.ibb.co/5XfQWS99/pexels-tauseef-khaliq-12750077-min-scaled.jpg",
    includes: [
      "Breakfast & dinner included",
      "Shikara ride on Dal Lake",
      "Srinagar city sightseeing",
      "Mughal Gardens & Shankaracharya",
      "Airport pickup & drop",
    ],
    duration: "2 Nights · 3 Days",
    price: "₹6,000",
    priceUnit: "/person",
    itinerary: "itinerary-srinagar-weekend.html",
    waText: "Hi! I'm interested in the Srinagar Weekend (2N/3D) at Al Mubeen Homestay.",
  },
  {
    name: "Classic Kashmir Tour",
    badge: "⭐ Most Popular",
    image: "https://i.ibb.co/YFdD2PTd/Getty-Images-1432005421-5c0bc8d84cedfd0001fa5acb.jpg",
    includes: [
      "Breakfast & dinner included",
      "Gulmarg day trip + Gondola ride",
      "Pahalgam & Betaab Valley",
      "Dal Lake Shikara ride",
      "Srinagar sightseeing",
      "Airport transfers",
    ],
    duration: "4 Nights · 5 Days",
    price: "₹11,000",
    priceUnit: "/person",
    itinerary: "itinerary-classic-kashmir-tour.html",
    waText: "Hi! I'm interested in the Classic Kashmir Tour (4N/5D) at Al Mubeen Homestay.",
  },
  {
    name: "Kashmir Family Tour",
    badge: "👨‍👩‍👧‍👦 Family Special",
    image: "https://i.ibb.co/YFdD2PTd/Getty-Images-1432005421-5c0bc8d84cedfd0001fa5acb.jpg",
    includes: [
      "Breakfast & dinner included",
      "Gulmarg + Pahalgam + Sonmarg",
      "Shikara ride",
      "Srinagar sightseeing",
      "Airport transfers",
    ],
    duration: "5 Nights · 6 Days",
    price: "₹13,500",
    priceUnit: "/person",
    itinerary: "itinerary-kashmir-family-tour.html",
    waText: "Hi! I'm interested in the Kashmir Family Tour (5N/6D) at Al Mubeen Homestay.",
  },
  {
    name: "Romantic Getaway",
    badge: "❤️ Couples",
    image: "https://i.ibb.co/5XfQWS99/pexels-tauseef-khaliq-12750077-min-scaled.jpg",
    includes: [
      "Breakfast & dinner included",
      "Private Shikara sunset ride",
      "Gulmarg day trip",
      "Pahalgam excursion",
      "Flower welcome & room decoration",
    ],
    duration: "3 Nights · 4 Days",
    price: "₹10,500",
    priceUnit: "/person",
    itinerary: "itinerary-romantic-getaway.html",
    waText: "Hi! I'm interested in the Romantic Getaway (3N/4D) at Al Mubeen Homestay.",
  },
];

const GALLERY = [
  ASSETS.houseFront,
  ASSETS.bedroom,
  ASSETS.entryway,
  ASSETS.living,
  ASSETS.sittingRoom,
  ASSETS.rooftopSnow,
  ASSETS.bedroom2,
  ASSETS.exteriorMountain,
  "https://i.ibb.co/fV2KnTKL/Whats-App-Image-2026-05-25-at-22-25-21nh.jpg",
  "https://i.ibb.co/6K5tSfd/Whats-App-Image-2026-05-25-at-22-25-17.jpg",
  "https://i.ibb.co/201bXrds/Whats-App-Image-2026-05-25-at-22-25-20f.jpg",
  "https://i.ibb.co/TqtWfgCj/Whats-App-Image-2026-05-25-at-22-25-20hnhn.jpg",
  "https://i.ibb.co/pB5722Dk/Whats-App-Image-2026-05-25-at-22-25-20nh.jpg",
  "https://i.ibb.co/Y4JNMWp9/ww.jpg",
  "https://i.ibb.co/Z1bpShZd/6t346t.jpg",
  "https://i.ibb.co/FbMB9Wcs/5665.jpg",
  "https://i.ibb.co/35c7h8Qn/d.jpg",
  "https://i.ibb.co/JRjx55Bg/gt.jpg",
  "https://i.ibb.co/8DCTxhCQ/hh.jpg",
  "https://i.ibb.co/Z1pFbvYK/nyn.jpg",
  "https://i.ibb.co/QvF3nS6m/tt.jpg",
  "https://i.ibb.co/21YVPG18/Whats-App-Image-2026-05-25-at-13-23-48.jpg",
  "https://i.ibb.co/R4VZ8Hbk/Whats-App-Image-2026-05-25-at-13-23-49.jpg",
  "https://i.ibb.co/wZzM0GBG/Whats-App-Image-2026-05-25-at-13-23-49dw.jpg",
  "https://i.ibb.co/Wp21cztC/Whats-App-Image-2026-05-25-at-17-14-08.jpg",
  "https://i.ibb.co/q30RK6vC/Whats-App-Image-2026-05-25-at-21-03-26dwd.jpg",
  "https://i.ibb.co/xwssymt/Whats-App-Image-2026-05-25-at-21-03-28xqx.jpg",
  "https://i.ibb.co/zT2NNp4C/c.jpg",
];

// ------------------- Small components -------------------
const STAR_SLOTS = ["s1", "s2", "s3", "s4", "s5"];

const Stars = ({ n = 5 }) => (
  <div className="flex gap-0.5 text-[#C8932F]" aria-label={`${n} star rating`}>
    {STAR_SLOTS.map((slot, i) => (
      <i
        key={slot}
        className={`fa-${i < n ? "solid" : "regular"} fa-star text-xs`}
      ></i>
    ))}
  </div>
);

const SNOW_SLOTS = Array.from({ length: 28 }, (_, i) => ({
  id: `flake-${i}`,
  left: Math.random() * 100,
  dur: 9 + Math.random() * 14,
  delay: Math.random() * -20,
  size: 8 + Math.random() * 14,
}));

const Snowfall = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-[2]">
      {SNOW_SLOTS.map(({ id, left, dur, delay, size }) => {
        return (
          <span
            key={id}
            className="snowflake"
            style={{
              left: `${left}%`,
              animationDuration: `${dur}s`,
              animationDelay: `${delay}s`,
              fontSize: `${size}px`,
            }}
          >
            ❄
          </span>
        );
      })}
    </div> 
  );
};

// ------------------- Sections -------------------
const Nav = ({ active }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // setScrolled is stable from useState
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "glass-nav bg-[#FBF7EC]/85 border-b border-[#EFE6CE] py-2"
          : "bg-transparent py-4"
      }`}
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex items-center justify-between gap-6">
        <button
          onClick={() => go("home")}
          className="flex items-center gap-3 group shrink-0"
          data-testid="nav-logo"
        >
          <img
            src={ASSETS.logo}
            alt="Al Mubeen Homestay"
            className={`rounded-full ring-1 ring-[#C8932F]/40 transition-all shrink-0 ${
              scrolled ? "h-11 w-11" : "h-14 w-14"
            }`}
          />
          <div className="hidden sm:flex flex-col leading-tight text-left">
            <span className="font-display text-2xl text-[#2A1B0F] font-semibold whitespace-nowrap tracking-tight">
              Al Mubeen
            </span>
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#5C3A1F]/80 whitespace-nowrap">
              Vacation Homestay
            </span>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => go(n.id)}
              data-testid={`nav-link-${n.id}`}
              className={`relative px-4 py-2 text-[13px] tracking-wide uppercase font-medium transition-colors ${
                active === n.id
                  ? "text-[#2A1B0F]"
                  : "text-[#5C3A1F]/80 hover:text-[#2A1B0F]"
              }`}
            >
              {n.label}
              {active === n.id && (
                <span className="absolute left-1/2 -translate-x-1/2 bottom-0.5 h-[2px] w-6 bg-[#C8932F]" />
              )}
            </button>
          ))}
          <button
            onClick={() => { window.location.href = PACKAGES_URL; }}
            data-testid="nav-link-packages"
            className="relative px-4 py-2 text-[13px] tracking-wide uppercase font-medium transition-colors text-[#5C3A1F]/80 hover:text-[#2A1B0F]"
          >
            Packages
          </button>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${PHONE}`}
            data-testid="nav-call-btn"
            className="text-[13px] font-medium text-[#2A1B0F] hover:text-[#C8932F] transition-colors flex items-center gap-2"
          >
            <i className="fa-solid fa-phone text-[#C8932F]"></i>
            {PHONE}
          </a>
          <a
            href={`tel:${PHONE2}`}
            className="text-[13px] font-medium text-[#2A1B0F] hover:text-[#C8932F] transition-colors flex items-center gap-2"
          >
            <i className="fa-solid fa-phone text-[#C8932F]"></i>
            {PHONE2}
          </a>
          <a
            href={`${WHATSAPP_BASE}?text=${encodeURIComponent(
              "Hello Al Mubeen Homestay, I would like to book a stay."
            )}`}
            target="_top"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="px-5 py-2.5 rounded-full bg-[#2A1B0F] text-[#F7F1E1] text-sm font-medium hover:bg-[#5C3A1F] transition-colors inline-flex items-center gap-2"
          >
            <i className="fa-brands fa-whatsapp text-[#E0A93F]"></i>
            Book Now
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#2A1B0F]"
          aria-label="Toggle menu"
          data-testid="nav-toggle"
        >
          <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"} text-xl`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <div className="px-5 pb-6 pt-2 bg-[#FBF7EC] border-t border-[#EFE6CE]">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => go(n.id)}
              data-testid={`mobile-nav-${n.id}`}
              className="block w-full text-left py-3 border-b border-[#EFE6CE] font-display text-xl font-semibold text-[#2A1B0F] tracking-tight"
            >
              {n.label}
            </button>
          ))}
          <button
            onClick={() => { window.location.href = PACKAGES_URL; }}
            data-testid="mobile-nav-packages"
            className="block w-full text-left py-3 border-b border-[#EFE6CE] font-display text-xl font-semibold text-[#2A1B0F] tracking-tight"
          >
            Packages
          </button>
          <div className="flex flex-col gap-3 mt-5">
            <a
              href={`tel:${PHONE}`}
              className="px-5 py-3 rounded-full border-2 border-[#2A1B0F] text-[#2A1B0F] text-sm font-medium text-center"
            >
              <i className="fa-solid fa-phone mr-2"></i>
              {PHONE}
            </a>
            <a
              href={`${WHATSAPP_BASE}?text=${encodeURIComponent("Hello Al Mubeen Homestay")}`}
              target="_top"
              rel="noopener noreferrer"
              className="px-5 py-3 rounded-full bg-[#25D366] text-white text-sm font-medium text-center"
            >
              <i className="fa-brands fa-whatsapp mr-2"></i>
              WhatsApp Booking
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-[100vh] w-full overflow-hidden flex items-center"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <img
          src={ASSETS.exteriorMountain}
          alt="Al Mubeen Homestay with snow-capped mountains"
          className="w-full h-full object-cover slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2A1B0F]/55 via-[#2A1B0F]/35 to-[#2A1B0F]/85"></div>
      </div>
      <Snowfall />

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-10 pt-32 pb-20 w-full">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8 rise-in">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#E0A93F]"></span>
              <span className="text-[#E0A93F] uppercase text-xs tracking-[0.4em] font-medium">
                Nishat · Srinagar · Kashmir
              </span>
            </div>
            <h1 className="font-display text-[#F7F1E1] text-[54px] sm:text-[72px] lg:text-[104px] leading-[0.95] font-medium">
              Your Home
              <br />
              in <span className="italic text-[#E0A93F]">Kashmir.</span>
            </h1>
            <p className="font-script text-[#E0A93F] text-3xl mt-4">
              ~ a stay that feels like family
            </p>
            <p className="text-[#F7F1E1]/85 max-w-xl mt-6 text-base lg:text-lg leading-relaxed">
              Al Mubeen Homestay offers a warm, family-run retreat in Nishat —
              minutes from Dal Lake, Nishat Garden, Shalimar Garden, Tulip Garden & Chashme Shahi. Wake up to
              snow on rooftops, sip kahwa by the window, and explore Kashmir
              like a local.
            </p>

            <div className="flex flex-wrap gap-3 mt-9" data-testid="hero-cta-row">
              <a
                href={`${WHATSAPP_BASE}?text=${encodeURIComponent(
                  "Hi! I would like to book a stay at Al Mubeen Homestay."
                )}`}
                target="_top"
                rel="noopener noreferrer"
                data-testid="hero-whatsapp-btn"
                className="group px-7 py-4 rounded-full bg-[#25D366] text-white font-medium inline-flex items-center gap-3 hover:bg-[#1ebe5a] transition-all shadow-[0_20px_40px_-15px_rgba(37,211,102,0.6)]"
              >
                <i className="fa-brands fa-whatsapp text-xl"></i>
                Book on WhatsApp
                <i className="fa-solid fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a
                href={`tel:${PHONE}`}
                data-testid="hero-call-btn"
                className="px-7 py-4 rounded-full bg-[#F7F1E1] text-[#2A1B0F] font-medium inline-flex items-center gap-3 hover:bg-white transition-all"
              >
                <i className="fa-solid fa-phone"></i>
                Call {PHONE}
              </a>
              <button
                onClick={() =>
                  document.getElementById("rooms")?.scrollIntoView({ behavior: "smooth" })
                }
                data-testid="hero-rooms-btn"
                className="px-7 py-4 rounded-full border border-[#F7F1E1]/40 text-[#F7F1E1] font-medium inline-flex items-center gap-3 hover:bg-[#F7F1E1]/10 transition-all"
              >
                Explore Rooms
              </button>
              <a
                href="/packages.html"
                data-testid="hero-packages-btn"
                className="px-7 py-4 rounded-full border border-[#E0A93F]/70 text-[#E0A93F] font-medium inline-flex items-center gap-3 hover:bg-[#E0A93F]/10 transition-all"
              >
                🏔️ Explore Packages with Homestay Included
                <i className="fa-solid fa-arrow-right"></i>
              </a>
            </div>
            <p className="mt-3 text-[#F7F1E1]/60 text-sm italic">
              Stay at Al Mubeen Homestay while exploring Srinagar, Gulmarg &amp; Pahalgam.
            </p>

            <div className="mt-12 grid grid-cols-3 gap-4 max-w-xl">
              {[
                { k: "★ 4.9", v: "Guest Rating" },
                { k: "₹1,500", v: "Stays from / night" },
                { k: "5 min", v: "to Dal Lake" },
              ].map((s, i) => (
                <div
                  key={s.v}
                  className="border-l-2 border-[#E0A93F]/60 pl-4"
                  data-testid={`hero-stat-${i}`}
                >
                  <div className="font-bold text-[#F7F1E1] text-2xl lg:text-3xl tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
                    {s.k}
                  </div>
                  <div className="text-[#F7F1E1]/70 text-xs uppercase tracking-widest mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Floating booking card */}
          <div className="lg:col-span-4 rise-in" style={{ animationDelay: "0.2s" }}>
            <div className="bg-[#FBF7EC]/95 backdrop-blur-md rounded-2xl p-6 lg:p-7 border border-[#EFE6CE] shadow-[0_30px_60px_-20px_rgba(0,0,0,0.45)]">
              <div className="flex items-center gap-3 mb-5">
                <img
                  src={ASSETS.logo}
                  alt="logo"
                  className="h-12 w-12 rounded-full ring-2 ring-[#C8932F]/40"
                />
                <div>
                  <div className="font-sans text-xl text-[#2A1B0F] font-bold leading-none tracking-tight">
                    Quick Booking
                  </div>
                  <div className="text-xs text-[#5C3A1F]/70 mt-1">
                    Direct call & WhatsApp
                  </div>
                </div>
              </div>

              <div className="space-y-2 text-sm">
                {ROOMS.map((r, i) => (
                  <a
                    key={r.package}
                    href={`${WHATSAPP_BASE}?text=${encodeURIComponent(
                      `Hi! I'm interested in the "${r.package}" at Al Mubeen Homestay (${r.price} ${r.unit}). Please share availability.`
                    )}`}
                    target="_top"
                    rel="noopener noreferrer"
                    data-testid={`hero-quick-${i}`}
                    className="flex items-center justify-between gap-2 p-3 rounded-xl border border-[#EFE6CE] hover:border-[#C8932F] hover:bg-[#F7F1E1] transition-all group"
                  >
                    <div className="flex-1 min-w-0">
                      <div className="font-display font-semibold text-[#2A1B0F] text-xs leading-tight">{r.name}</div>
                      <div className="text-[#5C3A1F]/65 text-[10px] mt-0.5">{r.subtitle}</div>
                    </div>
                    <div className="text-right shrink-0">
                      <div className="font-bold text-sm text-[#2A1B0F] tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>{r.price}</div>
                      <div className="text-[10px] uppercase tracking-wider text-[#5C3A1F]/60">{r.unit}</div>
                    </div>
                  </a>
                ))}
              </div>

              {/* Trust badges */}
              <div className="mt-4 pt-4 border-t border-[#EFE6CE] flex flex-wrap gap-x-2 gap-y-1 text-[10px] text-[#5C3A1F]/75">
                <span>📍 Near Dal Lake &amp; Nishat Garden</span>
                <span>🏡 Family-Run Homestay</span>
                <span>⭐ Highly Rated by Guests</span>
              </div>

              {/* Packages CTA */}
              <a
                href="/packages.html"
                className="mt-3 flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border border-[#C8932F]/60 text-[#5C3A1F] text-xs font-semibold hover:bg-[#C8932F]/10 hover:border-[#C8932F] transition-all"
              >
                🏔️ Explore Packages with Homestay Included
                <i className="fa-solid fa-arrow-right text-[#C8932F] text-[10px]"></i>
              </a>
              <p className="text-center text-[10px] text-[#5C3A1F]/50 mt-1 italic">
                Srinagar, Gulmarg &amp; Pahalgam tours with stay included.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[#F7F1E1]/70 text-xs tracking-[0.3em] uppercase flex flex-col items-center gap-2 z-10">
        <span>scroll</span>
        <span className="h-8 w-px bg-[#F7F1E1]/40 animate-pulse"></span>
      </div>
    </section>
  );
};

const Marquee = () => {
  const items = [
    "Authentic Kashmiri Wazwan",
    "Steps from Dal Lake",
    "Family-run since generations",
    "Snow on rooftops in winter",
    "Custom Tour Packages",
    "Pay at homestay",
    "Local guidance from hosts",
  ];
  const dup = [...items, ...items];
  return (
    <div className="relative bg-[#2A1B0F] text-[#F7F1E1] py-5 overflow-hidden border-y border-[#5C3A1F]">
      <div className="marquee-track flex gap-12 whitespace-nowrap w-max">
        {dup.map((t, i) => (
          <div key={`marquee-${i}-${t}`} className="flex items-center gap-12 font-display text-2xl italic">
            <span>{t}</span>
            <span className="text-[#E0A93F]">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const About = () => (
  <section
    id="about"
    className="relative py-24 lg:py-32 paper-grain bg-[#FBF7EC]"
    data-testid="about-section"
  >
    <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-14 items-center relative z-10">
      <div className="lg:col-span-5 relative">
        <div className="relative">
          <img
            src="https://i.ibb.co/KxHTYwrq/Whats-App-Image-2026-09-26-at-17-03-54-Copy.jpg"
            alt="Al Mubeen Homestay at night"
            className="w-full rounded-tl-[80px] rounded-br-[80px] object-cover aspect-[4/5] shadow-2xl"
          />
          <img
            src={ASSETS.rooftopSnow}
            alt="Snow rooftops in Srinagar"
            className="absolute -bottom-10 -right-6 lg:-right-12 w-[55%] aspect-square object-cover rounded-tl-[60px] rounded-br-[60px] border-8 border-[#FBF7EC] shadow-xl tilt-card"
          />
          <div className="absolute -top-6 -left-6 bg-[#C8932F] text-[#2A1B0F] rounded-full h-28 w-28 flex flex-col items-center justify-center shadow-lg">
            <span className="text-3xl font-bold leading-none">★ 4.9</span>
            <span className="text-[10px] tracking-widest uppercase mt-1">Loved</span>
          </div>
        </div>
      </div>

      <div className="lg:col-span-7">
        <div className="ornament mb-6">
          <span className="font-script text-2xl">about us</span>
        </div>
        <h2 className="font-display text-5xl lg:text-6xl text-[#2A1B0F] leading-tight font-medium">
          A Kashmiri home,
          <br />
          <span className="italic text-[#5C3A1F]">opened</span> for the world.
        </h2>
        <p className="text-[#3E2A1A]/85 mt-6 text-lg leading-relaxed">
          Tucked in the peaceful lanes of <strong>Nishat Brein</strong>,
          Al Mubeen Homestay is a budget-friendly retreat where guests are
          treated like family. Whether it's the aroma of a slow-cooked Rogan
          Josh, the warmth of Kashmiri quilts, or stories shared over kahwa,
          every moment here is a gentle reminder of Kashmir's legendary
          hospitality.
        </p>

        <div className="grid sm:grid-cols-2 gap-5 mt-10">
          {[
            {
              icon: "fa-house-chimney",
              t: "Family Hosted",
              d: "Personal care, never a check-in counter.",
            },
            {
              icon: "fa-utensils",
              t: "Home-Cooked Meals",
              d: "Authentic Kashmiri Wazwan & kahwa.",
            },
            {
              icon: "fa-mountain-sun",
              t: "Prime Location",
              d: "Walk to Dal Lake & Mughal Gardens.",
            },
            {
              icon: "fa-route",
              t: "Local Tour Help",
              d: "Trusted drivers & custom itineraries.",
            },
          ].map((f, i) => (
            <div
              key={f.t}
              data-testid={`about-feat-${i}`}
              className="flex gap-4 items-start p-4 rounded-2xl hover:bg-[#F7F1E1] transition-colors"
            >
              <div className="h-12 w-12 rounded-xl bg-[#2A1B0F] text-[#E0A93F] flex items-center justify-center shrink-0">
                <i className={`fa-solid ${f.icon}`}></i>
              </div>
              <div>
                <div className="font-sans text-xl text-[#2A1B0F] font-bold tracking-tight">
                  {f.t}
                </div>
                <p className="text-[#5C3A1F]/80 text-sm mt-1">{f.d}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-4">
          <a
            href={`${WHATSAPP_BASE}?text=${encodeURIComponent("Hi! Tell me more about Al Mubeen Homestay.")}`}
            target="_top"
            rel="noopener noreferrer"
            className="px-6 py-3 rounded-full bg-[#2A1B0F] text-[#F7F1E1] text-sm font-medium inline-flex items-center gap-2 hover:bg-[#5C3A1F] transition"
            data-testid="about-whatsapp-btn"
          >
            <i className="fa-brands fa-whatsapp"></i> Chat with hosts
          </a>
        </div>
      </div>
    </div>
  </section>
);

const Rooms = () => (
  <section
    id="rooms"
    className="relative py-24 lg:py-32 bg-[#F7F1E1]"
    data-testid="rooms-section"
  >
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
        <div>
          <div className="ornament mb-4 max-w-[260px]">
            <span className="font-script text-2xl">stay with us</span>
          </div>
          <h2 className="font-display text-5xl lg:text-6xl text-[#2A1B0F] font-medium leading-tight">
            Rooms &amp; <span className="italic">Packages</span>
          </h2>
        </div>
        <p className="text-[#5C3A1F]/85 max-w-md text-base">
          Choose just a room, add Kashmiri home food, or go all-in with our
          curated tour package. Prices may vary slightly with season.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-7" data-testid="rooms-grid">
        {ROOMS.map((r, i) => (
          <article
            key={r.name}
            data-testid={`room-card-${i}`}
            className="group bg-[#FBF7EC] rounded-3xl overflow-hidden border border-[#EFE6CE] tilt-card flex flex-col"
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={r.image}
                alt={r.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <span className="absolute top-4 left-4 bg-[#2A1B0F] text-[#E0A93F] text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 rounded-full font-medium">
                {r.tag}
              </span>
            </div>
            <div className="p-7 flex flex-col flex-1">
              <h3 className="font-display text-3xl text-[#2A1B0F] font-bold">
                {r.name}
              </h3>
              <div className="flex items-baseline gap-2 mt-2">
                <span className="text-4xl font-bold text-[#5C3A1F] tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
                  {r.price}
                </span>
                <span className="text-xs font-semibold uppercase tracking-widest text-[#5C3A1F]/60" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
                  {r.unit}
                </span>
              </div>
              <p className="text-[#3E2A1A]/85 mt-4 text-sm leading-relaxed">{r.desc}</p>

              <ul className="mt-5 grid grid-cols-2 gap-2 text-sm text-[#3E2A1A]">
                {r.features.map((f) => (
                  <li key={f} className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#C8932F] text-xs"></i>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href={`${WHATSAPP_BASE}?text=${encodeURIComponent(
                  `Hi Al Mubeen, I would like to book the "${r.package}" (${r.price} ${r.unit}). Please share availability.`
                )}`}
                target="_top"
                rel="noopener noreferrer"
                data-testid={`room-book-${i}`}
                className="mt-7 inline-flex items-center justify-center gap-2 w-full px-5 py-3.5 rounded-full bg-[#2A1B0F] text-[#F7F1E1] font-medium hover:bg-[#5C3A1F] transition group/btn"
              >
                <i className="fa-brands fa-whatsapp text-[#E0A93F]"></i>
                Book this stay
                <i className="fa-solid fa-arrow-right text-xs group-hover/btn:translate-x-1 transition-transform"></i>
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const Tours = () => (
  <section
    id="tours"
    className="relative py-24 lg:py-32 bg-[#2A1B0F] text-[#F7F1E1] overflow-hidden"
    data-testid="tours-section"
  >
    <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #E0A93F 0%, transparent 40%), radial-gradient(circle at 80% 70%, #C8932F 0%, transparent 40%)",
        }}
      ></div>
    </div>
    <div className="max-w-7xl mx-auto px-5 lg:px-10 relative z-10">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <div className="ornament mb-4 justify-center">
          <span className="font-script text-2xl text-[#E0A93F]">explore kashmir</span>
        </div>
        <h2 className="font-display text-5xl lg:text-6xl font-medium leading-tight">
          Curated <span className="italic text-[#E0A93F]">tour packages</span>
        </h2>
        <p className="text-[#F7F1E1]/70 mt-5 text-base">
          Every Kashmir journey, crafted by our hosts with trusted local drivers
          who know the valleys, passes and hidden gems like the back of their hands.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto" data-testid="tours-grid">
        {TOURS.map((t, i) => (
          <div
            key={t.name}
            data-testid={`tour-card-${i}`}
            className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#5C3A1F] to-[#2A1B0F] aspect-[4/5] flex flex-col"
          >
            <img
              src={t.image}
              alt={t.name}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
            />
            {/* Badge */}
            <div className="absolute top-4 left-4 z-10">
              <span className="bg-[#E0A93F] text-[#2A1B0F] text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full">
                {t.badge}
              </span>
            </div>
            {/* Strong gradient so text is always readable over photo */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A0F07] via-[#1A0F07]/80 via-40% to-transparent"></div>
            <div className="absolute left-5 right-5 bottom-5 z-10">
              <h3 className="font-display font-semibold text-2xl text-[#F7F1E1] leading-tight drop-shadow-lg">
                {t.name}
              </h3>
              <p className="text-[#E0A93F] text-[10px] tracking-widest uppercase mt-1 font-medium">
                {t.duration}
              </p>
              <ul className="mt-2.5 space-y-1">
                {t.includes.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-1.5 text-[#F7F1E1] text-[11px] leading-relaxed">
                    <span className="text-[#E0A93F] mt-0.5 shrink-0">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mt-3 pt-3 border-t border-[#F7F1E1]/15">
                <div className="text-[#F7F1E1]/50 text-[9px] uppercase tracking-[0.2em] font-medium mb-0.5">Starting from</div>
                <div className="flex items-baseline gap-1">
                  <span className="text-2xl font-bold text-[#E0A93F] tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
                    {t.price}
                  </span>
                  <span className="text-sm font-medium text-[#F7F1E1]/60" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>{t.priceUnit}</span>
                </div>
              </div>
              <div className="mt-3 flex gap-2">
                <a
                  href={t.itinerary}
                  target="_top"
                  className="flex-1 text-center text-[11px] font-semibold py-2 px-3 rounded-full border border-[#E0A93F] text-[#E0A93F] hover:bg-[#E0A93F] hover:text-[#2A1B0F] transition-all"
                >
                  View Itinerary
                </a>
                <a
                  href={`${WHATSAPP_BASE}?text=${encodeURIComponent(t.waText)}`}
                  target="_top"
                  rel="noopener noreferrer"
                  className="flex-1 text-center text-[11px] font-semibold py-2 px-3 rounded-full bg-[#E0A93F] text-[#2A1B0F] hover:bg-[#C8932F] transition-all"
                >
                  Book Now
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-12">
        <a
          href={PACKAGES_URL}
          data-testid="tours-view-all-btn"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#E0A93F] text-[#2A1B0F] font-medium hover:bg-[#C8932F] transition-all text-sm tracking-wide"
        >
          View All Packages
          <i className="fa-solid fa-arrow-right text-xs"></i>
        </a>
      </div>
    </div>
  </section>
);

const Gallery = () => {
  const [active, setActive] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const PREVIEW_COUNT = 8;
  const visible = showAll ? GALLERY : GALLERY.slice(0, PREVIEW_COUNT);
  const hasMore = GALLERY.length > PREVIEW_COUNT;

  // Open lightbox at a given index for prev/next navigation
  const openAt = (idx) => setActive(idx);
  const closeLightbox = () => setActive(null);
  const next = (e) => {
    e?.stopPropagation();
    setActive((i) => (i === null ? 0 : (i + 1) % GALLERY.length));
  };
  const prev = (e) => {
    e?.stopPropagation();
    setActive((i) => (i === null ? 0 : (i - 1 + GALLERY.length) % GALLERY.length));
  };

  // Keyboard navigation
  useEffect(() => {
    if (active === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  return (
    <section
      id="gallery"
      className="relative py-24 lg:py-32 bg-[#FBF7EC]"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="ornament mb-4 justify-center">
            <span className="font-script text-2xl">moments</span>
          </div>
          <h2 className="font-display text-5xl lg:text-6xl text-[#2A1B0F] font-medium leading-tight">
            A peek into <span className="italic">our world</span>
          </h2>
          <p className="text-[#5C3A1F]/80 mt-4 text-sm">
            {GALLERY.length} photos from our homestay & Kashmir
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="gallery-grid">
          {visible.map((src, i) => (
            <button
              key={src}
              onClick={() => openAt(i)}
              data-testid={`gallery-img-${i}`}
              className="relative overflow-hidden rounded-2xl group aspect-square bg-gradient-to-br from-[#5C3A1F] to-[#2A1B0F]"
            >
              <img
                src={src}
                alt={`Gallery ${i + 1}`}
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#2A1B0F]/0 group-hover:bg-[#2A1B0F]/40 transition-colors flex items-center justify-center">
                <i className="fa-solid fa-expand text-[#F7F1E1] opacity-0 group-hover:opacity-100 transition-opacity text-xl"></i>
              </div>
              {/* Overlay "+N more" on last preview tile when collapsed */}
              {!showAll && hasMore && i === PREVIEW_COUNT - 1 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAll(true);
                  }}
                  className="absolute inset-0 bg-[#2A1B0F]/75 backdrop-blur-sm flex flex-col items-center justify-center text-[#F7F1E1] hover:bg-[#2A1B0F]/85 transition-colors"
                  data-testid="gallery-show-more-tile"
                >
                  <span className="font-bold text-4xl lg:text-5xl tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
                    +{GALLERY.length - PREVIEW_COUNT}
                  </span>
                  <span className="text-xs uppercase tracking-[0.3em] mt-1">more</span>
                </button>
              )}
            </button>
          ))}
        </div>

        {hasMore && (
          <div className="flex justify-center mt-10">
            <button
              onClick={() => setShowAll((v) => !v)}
              data-testid="gallery-toggle-all"
              className="px-7 py-3.5 rounded-full bg-[#2A1B0F] text-[#F7F1E1] font-medium inline-flex items-center gap-2 hover:bg-[#5C3A1F] transition"
            >
              {showAll ? (
                <>
                  <i className="fa-solid fa-chevron-up"></i> Show fewer photos
                </>
              ) : (
                <>
                  <i className="fa-solid fa-images"></i>
                  View all {GALLERY.length} photos
                  <i className="fa-solid fa-arrow-right text-xs"></i>
                </>
              )}
            </button>
          </div>
        )}
      </div>

      {active !== null && (
        <div
          onClick={closeLightbox}
          className="fixed inset-0 z-50 bg-[#2A1B0F]/95 backdrop-blur-md flex items-center justify-center p-4 sm:p-6"
          data-testid="gallery-lightbox"
        >
          <img
            src={GALLERY[active]}
            alt={`Expanded ${active + 1}`}
            className="max-h-[88vh] max-w-[92vw] rounded-2xl object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />

          {/* Counter */}
          <div className="absolute top-6 left-1/2 -translate-x-1/2 px-4 py-2 rounded-full bg-[#F7F1E1]/15 backdrop-blur text-[#F7F1E1] text-xs tracking-widest uppercase">
            {active + 1} / {GALLERY.length}
          </div>

          {/* Prev / Next */}
          {GALLERY.length > 1 && (
            <>
              <button
                onClick={prev}
                data-testid="gallery-prev"
                aria-label="Previous photo"
                className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-[#F7F1E1]/15 backdrop-blur hover:bg-[#F7F1E1]/30 text-[#F7F1E1] text-lg transition"
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                onClick={next}
                data-testid="gallery-next"
                aria-label="Next photo"
                className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-[#F7F1E1]/15 backdrop-blur hover:bg-[#F7F1E1]/30 text-[#F7F1E1] text-lg transition"
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </>
          )}

          <button
            className="absolute top-6 right-6 h-12 w-12 rounded-full bg-[#F7F1E1] text-[#2A1B0F] text-xl hover:bg-white transition"
            onClick={closeLightbox}
            data-testid="gallery-close"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
      )}
    </section>
  );
};

// --- Elfsight Google Reviews (script-based embed with iframe fallback) ---
const GoogleReviewsEmbed = ({ widgetId, onFail }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!widgetId) return;
    const src = "https://elfsightcdn.com/platform.js";
    if (!document.querySelector(`script[src="${src}"]`)) {
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.defer = true;
      document.body.appendChild(s);
    }
    // If Elfsight doesn't populate the container within 7s, trigger fallback.
    const timer = setTimeout(() => {
      const el = containerRef.current;
      if (!el || el.childElementCount === 0) {
        onFail?.();
      }
    }, 7000);
    return () => clearTimeout(timer);
  }, [widgetId, onFail]);

  if (!widgetId) return null;
  return (
    <div
      ref={containerRef}
      data-testid="elfsight-google-reviews"
      className={`elfsight-app-${widgetId}`}
      data-elfsight-app-lazy
      style={{ minHeight: "400px" }}
    ></div>
  );
};

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [elfFailed, setElfFailed] = useState(false);
  const useGoogle = Boolean(GOOGLE_REVIEWS_WIDGET_ID) && !elfFailed;

  useEffect(() => {
    // Always fetch seeded reviews so we have a fallback ready
    axios
      .get(`${API}/reviews`)
      .then((r) => setReviews(r.data || []))
      .catch(() => setReviews([]));
    // API and axios are module-level constants
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section
      id="reviews"
      className="relative py-24 lg:py-32 bg-[#F7F1E1] paper-grain"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <div className="ornament mb-4 max-w-[200px]">
              <span className="font-script text-2xl">guest love</span>
            </div>
            <h2 className="font-display text-5xl lg:text-6xl text-[#2A1B0F] font-medium leading-tight">
              Stories from
              <br />
              <span className="italic">our family.</span>
            </h2>
            <p className="text-[#5C3A1F]/85 mt-5 text-base">
              Real notes from travellers who walked in as guests and left as
              extended family.
            </p>
            <div className="mt-7 flex items-center gap-4">
              <div className="font-sans text-6xl text-[#2A1B0F] font-bold tracking-tight">4.9</div>
              <div>
                <Stars n={5} />
                <p className="text-xs text-[#5C3A1F]/70 mt-1">
                  {useGoogle
                    ? "Live from Google Reviews"
                    : `Across ${reviews.length || 5}+ reviews`}
                </p>
              </div>
            </div>

            <a
              href={GOOGLE_MAPS_URL}
              target="_top"
              rel="noopener noreferrer"
              data-testid="reviews-google-link"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#FBF7EC] border border-[#EFE6CE] hover:border-[#C8932F] transition text-sm text-[#2A1B0F]"
            >
              <i className="fa-brands fa-google text-[#C8932F]"></i>
              Review us on Google
              <i className="fa-solid fa-arrow-up-right-from-square text-xs"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            {useGoogle ? (
              <div className="bg-[#FBF7EC] rounded-3xl p-4 sm:p-6 border border-[#EFE6CE]">
                <GoogleReviewsEmbed
                  widgetId={GOOGLE_REVIEWS_WIDGET_ID}
                  onFail={() => setElfFailed(true)}
                />
              </div>
            ) : (
              <div className="grid md:grid-cols-2 gap-5" data-testid="reviews-grid">
                {reviews.slice(0, 6).map((r, i) => (
                  <div
                    key={r.id || i}
                    data-testid={`review-card-${i}`}
                    className={`bg-[#FBF7EC] rounded-3xl p-7 border border-[#EFE6CE] tilt-card ${
                      i % 3 === 0 ? "md:translate-y-6" : ""
                    }`}
                  >
                    <i className="fa-solid fa-quote-left text-[#C8932F] text-2xl"></i>
                    <p className="text-[#3E2A1A] mt-3 text-sm lg:text-base leading-relaxed">
                      {r.comment}
                    </p>
                    <div className="mt-5 pt-5 border-t border-[#EFE6CE] flex items-center justify-between">
                      <div>
                        <div className="font-sans text-lg text-[#2A1B0F] font-bold leading-tight tracking-tight">
                          {r.name}
                        </div>
                        {r.location && (
                          <div className="text-[#5C3A1F]/70 text-xs mt-0.5">{r.location}</div>
                        )}
                      </div>
                      <Stars n={r.rating || 5} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    check_in: "",
    check_out: "",
    guests: 2,
    package: "Room + Food",
    message: "",
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [status, setStatus] = useState({ state: "idle", text: "" });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      setStatus({ state: "error", text: "Please fill your name and phone number." });
      return;
    }

    setStatus({ state: "loading", text: "Sending..." });

    // Send email via EmailJS
    emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        from_name: form.name,
        name: form.name,
        phone: form.phone,
        from_email: form.email || "Not provided",
        email: form.email || "Not provided",
        checkin: form.check_in || "Not specified",
        checkout: form.check_out || "Not specified",
        guests: String(form.guests),
        package: form.package,
        message: form.message || "None",
        reply_to: form.email || "almubeen7007@gmail.com",
      },
      EMAILJS_PUBLIC_KEY
    ).then(() => {
      setStatus({ state: "success", text: "✅ Enquiry sent!" });
      setShowSuccess(true);
      setForm({
        name: "",
        phone: "",
        email: "",
        check_in: "",
        check_out: "",
        guests: 2,
        package: "Room + Food",
        message: "",
      });
    }).catch((err) => {
      console.error("EmailJS error status:", err.status);
      console.error("EmailJS error text:", err.text);
      console.error("EmailJS full error:", JSON.stringify(err));
      setStatus({ state: "error", text: `Email failed (${err.status}: ${err.text}). Please call or WhatsApp us.` });
    });

    // Post to backend silently
    axios.post(`${API}/inquiries`, form).catch(() => {});
  };

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <section
      id="contact"
      className="relative py-24 lg:py-32 bg-[#FBF7EC]"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="ornament mb-4 max-w-[220px]">
              <span className="font-script text-2xl">say hello</span>
            </div>
            <h2 className="font-display text-5xl lg:text-6xl text-[#2A1B0F] font-medium leading-tight">
              Book your <span className="italic">Kashmir</span> stay.
            </h2>
            <p className="text-[#5C3A1F]/85 mt-5">
              We respond personally on WhatsApp within minutes. Or simply pick up
              the phone — there's a real Kashmiri host on the other side, not
              an AI bot.
            </p>

            <div className="mt-8 space-y-5">
              <a
                href={`tel:${PHONE}`}
                data-testid="contact-call-link"
                className="flex items-center gap-4 p-4 rounded-2xl bg-[#F7F1E1] border border-[#EFE6CE] hover:border-[#C8932F] transition group"
              >
                <div className="h-12 w-12 rounded-xl bg-[#2A1B0F] text-[#E0A93F] flex items-center justify-center">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#5C3A1F]/70">Call us</div>
                  <div className="font-semibold text-lg text-[#2A1B0F] tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>{PHONE}</div>
                  <div className="font-semibold text-lg text-[#C8932F] tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>{PHONE2}</div>
                </div>
                <i className="fa-solid fa-arrow-right ml-auto text-[#C8932F] group-hover:translate-x-1 transition-transform"></i>
              </a>

              <a
                href={`${WHATSAPP_BASE}?text=${encodeURIComponent(
                  "Hi Al Mubeen! I'd like to enquire about a stay."
                )}`}
                target="_top"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-link"
                className="flex items-center gap-4 p-4 rounded-2xl bg-[#25D366] text-white hover:bg-[#1ebe5a] transition group"
              >
                <div className="h-12 w-12 rounded-xl bg-white/20 flex items-center justify-center">
                  <i className="fa-brands fa-whatsapp text-2xl"></i>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest opacity-90">WhatsApp</div>
                  <div className="font-bold text-xl tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>Chat instantly</div>
                </div>
                <i className="fa-solid fa-arrow-right ml-auto group-hover:translate-x-1 transition-transform"></i>
              </a>

              <div className="flex items-center gap-4 p-4 rounded-2xl bg-[#F7F1E1] border border-[#EFE6CE]">
                <div className="h-12 w-12 rounded-xl bg-[#2A1B0F] text-[#E0A93F] flex items-center justify-center">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#5C3A1F]/70">Location</div>
                  <div className="font-semibold text-lg text-[#2A1B0F] leading-tight tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
                    Nishat Brein, Srinagar
                  </div>
                  <div className="text-xs text-[#5C3A1F]/70">
                    Jammu &amp; Kashmir, India · Near Dal Lake &amp; Nishat Garden
                  </div>
                </div>
              </div>

              <a
                href="https://mail.google.com/mail/?view=cm&to=almubeen7007@gmail.com&su=Inquiry%20-%20Al%20Mubeen%20Homestay"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 rounded-2xl bg-[#F7F1E1] border border-[#EFE6CE] hover:border-[#C8932F] transition group"
              >
                <div className="h-12 w-12 rounded-xl bg-[#2A1B0F] text-[#E0A93F] flex items-center justify-center">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#5C3A1F]/70">Email us</div>
                  <div className="font-semibold text-base text-[#2A1B0F] leading-tight tracking-tight" style={{fontFamily:"'Plus Jakarta Sans',sans-serif"}}>almubeen7007@gmail.com</div>
                  <div className="text-xs text-[#5C3A1F]/70">We reply within a few hours</div>
                </div>
                <i className="fa-solid fa-arrow-right ml-auto text-[#C8932F] group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>

            <div className="mt-8 rounded-2xl overflow-hidden border border-[#EFE6CE] aspect-[16/10]">
              <iframe
                title="Al Mubeen Homestay Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d826.5!2d74.8872081!3d34.1149037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38e187591dba2649%3A0xdcf6eb32b3b9364f!2sAl%20Mubeen!5e0!3m2!1sen!2sin!4v1"
                width="100%"
                height="100%"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              ></iframe>
            </div>
          </div>

          <div className="lg:col-span-7">
            <form
              onSubmit={submit}
              data-testid="inquiry-form"
              className="bg-[#2A1B0F] text-[#F7F1E1] rounded-3xl p-7 lg:p-10 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.4)]"
            >
              <h3 className="font-display text-3xl lg:text-4xl font-medium">
                Book a <span className="italic text-[#E0A93F]">Room</span>
              </h3>
              <p className="text-[#F7F1E1]/70 mt-2 text-sm">
                Fill in your dates and we'll confirm availability via WhatsApp within minutes.
              </p>

              <div className="grid sm:grid-cols-2 gap-4 mt-7">
                <Field label="Your Name *">
                  <input
                    required
                    value={form.name}
                    onChange={update("name")}
                    data-testid="form-name"
                    className="form-input"
                    placeholder="Eg. Aarav Sharma"
                  />
                </Field>
                <Field label="Phone *">
                  <input
                    required
                    value={form.phone}
                    onChange={update("phone")}
                    data-testid="form-phone"
                    className="form-input"
                    placeholder="+91 ..."
                  />
                </Field>
                <Field label="Email">
                  <input
                    type="email"
                    value={form.email}
                    onChange={update("email")}
                    data-testid="form-email"
                    className="form-input"
                    placeholder="you@example.com"
                  />
                </Field>
                <Field label="Guests">
                  <input
                    type="number"
                    min={1}
                    max={20}
                    value={form.guests}
                    onChange={update("guests")}
                    data-testid="form-guests"
                    className="form-input"
                  />
                </Field>
                <Field label="Check-in">
                  <input
                    type="date"
                    value={form.check_in}
                    onChange={update("check_in")}
                    data-testid="form-checkin"
                    className="form-input"
                  />
                </Field>
                <Field label="Check-out">
                  <input
                    type="date"
                    value={form.check_out}
                    onChange={update("check_out")}
                    data-testid="form-checkout"
                    className="form-input"
                  />
                </Field>
                <Field label="Room Type" full>
                  <select
                    value={form.package}
                    onChange={update("package")}
                    data-testid="form-package"
                    className="form-input"
                  >
                    <option value="">-- Select --</option>
                    <option value="Double Room + Breakfast &amp; Dinner">Double Room + Breakfast &amp; Dinner (₹2,000/night)</option>
                    <option value="Triple Room + Breakfast &amp; Dinner">Triple Room + Breakfast &amp; Dinner (₹2,800/night)</option>
                    <option value="Family Room + Breakfast &amp; Dinner">Family Room – 2 Beds, 4 People + Breakfast &amp; Dinner (₹3,500/night)</option>
                    <option value="Custom">Custom — let's discuss</option>
                  </select>
                </Field>
                <Field label="Message" full>
                  <textarea
                    value={form.message}
                    onChange={update("message")}
                    data-testid="form-message"
                    rows={4}
                    className="form-input resize-none"
                    placeholder="Tell us about your trip — destinations, dietary needs, anything else..."
                  ></textarea>
                </Field>
              </div>

              <div className="mt-7 flex flex-wrap items-center gap-4">
                <button
                  type="submit"
                  disabled={status.state === "loading"}
                  data-testid="form-submit"
                  className="px-7 py-3.5 rounded-full bg-[#E0A93F] text-[#2A1B0F] font-medium inline-flex items-center gap-2 hover:bg-[#C8932F] transition disabled:opacity-60"
                >
                  {status.state === "loading" ? (
                    <>
                      <i className="fa-solid fa-spinner fa-spin"></i> Sending...
                    </>
                  ) : (
                    <>
                      Send Enquiry <i className="fa-solid fa-paper-plane"></i>
                    </>
                  )}
                </button>
                <a
                  href={`https://wa.me/${PHONE_DIGITS}?text=${encodeURIComponent(
                    form.name
                      ? [
                          "🏡 *New Booking Enquiry — Al Mubeen Homestay*",
                          "",
                          `👤 *Name:* ${form.name}`,
                          form.phone && `📞 *Phone:* ${form.phone}`,
                          form.email && `📧 *Email:* ${form.email}`,
                          form.check_in && `📅 *Check-in:* ${form.check_in}`,
                          form.check_out && `📅 *Check-out:* ${form.check_out}`,
                          `👥 *Guests:* ${form.guests}`,
                          `📦 *Package:* ${form.package}`,
                          form.message && `💬 *Message:* ${form.message}`,
                        ].filter(Boolean).join("\n")
                      : "Hi Al Mubeen Homestay, I would like to book a stay."
                  )}`}
                  target="_top"
                  rel="noopener noreferrer"
                  className="px-7 py-3.5 rounded-full bg-[#25D366] text-white font-medium inline-flex items-center gap-2 hover:bg-[#1ebe5a] transition"
                  data-testid="form-whatsapp-alt"
                >
                  <i className="fa-brands fa-whatsapp"></i> Or WhatsApp directly
                </a>
              </div>

              {status.text && (
                <div
                  data-testid="form-status"
                  className={`mt-5 text-sm rounded-xl p-4 ${getStatusClass(status.state)}`}
                >
                  {status.text}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>

      <style>{`
        .form-input {
          width: 100%;
          background: rgba(247,241,225,0.07);
          border: 1px solid rgba(247,241,225,0.18);
          color: #F7F1E1;
          padding: 0.85rem 1rem;
          border-radius: 0.85rem;
          outline: none;
          transition: all 0.2s ease;
          font-family: inherit;
          font-size: 0.95rem;
        }
        .form-input::placeholder { color: rgba(247,241,225,0.45); }
        .form-input:focus {
          border-color: #E0A93F;
          background: rgba(247,241,225,0.12);
        }
        .form-input option { color: #2A1B0F; background: #F7F1E1; }
      `}</style>

      {/* Success Popup Modal */}
      {showSuccess && (
        <div
          className="fixed inset-0 z-[999] flex items-center justify-center p-5"
          style={{ background: "rgba(0,0,0,0.55)" }}
          onClick={() => setShowSuccess(false)}
        >
          <div
            className="bg-[#FBF7EC] rounded-3xl p-8 max-w-sm w-full text-center shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-5xl mb-4">🎉</div>
            <h3 className="font-display text-2xl font-semibold text-[#2A1B0F] mb-2">
              Enquiry Sent!
            </h3>
            <p className="text-[#5C3A1F]/80 mb-1">
              Thank you for reaching out to <strong>Al Mubeen Homestay</strong>.
            </p>
            <p className="text-[#5C3A1F]/80 mb-6">
              The host will contact you shortly. We look forward to welcoming you to Kashmir! 🏔️
            </p>
            <button
              onClick={() => setShowSuccess(false)}
              className="px-7 py-3 rounded-full bg-[#2A1B0F] text-[#E0A93F] font-medium hover:bg-[#3d2812] transition w-full"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

const Field = ({ label, children, full }) => (
  <label className={`flex flex-col gap-2 ${full ? "sm:col-span-2" : ""}`}>
    <span className="text-[11px] uppercase tracking-[0.2em] text-[#F7F1E1]/70">{label}</span>
    {children}
  </label>
);

const getStatusClass = (state) => {
  if (state === "success") {
    return "bg-[#4F5D3A]/30 text-[#E0A93F] border border-[#4F5D3A]";
  }
  if (state === "error") {
    return "bg-[#A03B33]/20 text-[#F7F1E1] border border-[#A03B33]";
  }
  return "bg-[#5C3A1F]/40 text-[#F7F1E1]";
};

const Footer = () => (
  <footer className="bg-[#1B1109] text-[#F7F1E1]/85" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <div className="flex items-center gap-3">
          <img src={ASSETS.logo} alt="Logo" className="h-14 w-14 rounded-full ring-1 ring-[#C8932F]/40" />
          <div>
            <div className="font-sans text-2xl text-[#F7F1E1] font-bold leading-none tracking-tight">Al Mubeen</div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E0A93F] mt-1">Vacation Homestay</div>
          </div>
        </div>
        <p className="mt-5 text-sm max-w-md leading-relaxed">
          A family-run homestay in Nishat, Srinagar. We promise warm rooms,
          honest food and Kashmir the way it should be experienced — slowly,
          and with people who care.
        </p>
        <p className="font-script text-2xl text-[#E0A93F] mt-4">
          Experience Kashmir like family.
        </p>
      </div>

      <div className="lg:col-span-3">
        <h4 className="font-display text-xl text-[#F7F1E1] font-semibold mb-4">Quick links</h4>
        <ul className="space-y-2 text-sm">
          {NAV.map((n) => (
            <li key={n.id}>
              <button
                onClick={() => document.getElementById(n.id)?.scrollIntoView({ behavior: "smooth" })}
                className="hover:text-[#E0A93F] transition-colors"
                data-testid={`footer-link-${n.id}`}
              >
                {n.label}
              </button>
            </li>
          ))}
          <li>
            <a href={PACKAGES_URL} className="hover:text-[#E0A93F] transition-colors">
              Packages
            </a>
          </li>
        </ul>
      </div>

      <div className="lg:col-span-4">
        <h4 className="font-display text-xl text-[#F7F1E1] font-semibold mb-4">Reach us</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start gap-3">
            <i className="fa-solid fa-location-dot text-[#E0A93F] mt-1"></i>
            <span>108 Danpora, Nishat Brein Link Rd, Srinagar, Jammu &amp; Kashmir — 190001</span>
          </li>
          <li className="flex items-center gap-3">
            <i className="fa-solid fa-phone text-[#E0A93F]"></i>
            <div className="flex flex-col">
              <a href={`tel:${PHONE}`} className="hover:text-[#E0A93F]" data-testid="footer-phone">
                {PHONE}
              </a>
              <a href={`tel:${PHONE2}`} className="hover:text-[#E0A93F]">
                {PHONE2}
              </a>
            </div>
          </li>
          <li className="flex items-center gap-3">
            <i className="fa-solid fa-envelope text-[#E0A93F]"></i>
            <a href="https://mail.google.com/mail/?view=cm&to=almubeen7007@gmail.com&su=Inquiry%20-%20Al%20Mubeen%20Homestay" target="_blank" rel="noopener noreferrer" className="hover:text-[#E0A93F]">
              almubeen7007@gmail.com
            </a>
          </li>
          <li className="flex items-center gap-3">
            <i className="fa-brands fa-whatsapp text-[#E0A93F]"></i>
            <a
              href={`${WHATSAPP_BASE}`}
              target="_top"
              rel="noopener noreferrer"
              className="hover:text-[#E0A93F]"
              data-testid="footer-whatsapp"
            >
              WhatsApp us
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#5C3A1F]/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 flex flex-col items-center gap-4">
        <div className="flex flex-col sm:flex-row items-center gap-3 bg-[#2A1B0F] rounded-xl px-6 py-3 border border-[#C8932F]/30">
          <i className="fa-solid fa-award text-[#C8932F] text-xl"></i>
          <span className="text-[#F7F1E1]/90 text-sm text-center">Tours operated by <a href="https://indiaprivatetour.com/" target="_blank" rel="noopener noreferrer" className="text-[#E0A93F] font-semibold hover:underline">India Private Tour</a> — Recognised by <span className="text-[#F7F1E1]">Ministry of Tourism, Govt. of India</span></span>
          <a href="https://indiaprivatetour.com/" target="_blank" rel="noopener noreferrer" className="text-xs bg-[#C8932F] text-[#2A1B0F] font-bold px-3 py-1.5 rounded-full hover:bg-[#E0A93F] transition-colors whitespace-nowrap">Visit Website →</a>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-[#F7F1E1]/60 w-full">
          <span>© {new Date().getFullYear()} Al Mubeen Homestay. Made with warmth in Kashmir.</span>
          <span className="font-script text-base text-[#E0A93F]">Affordable Stay · Near Dal Lake</span>
        </div>
      </div>
    </div>
  </footer>
);

const WhatsAppFAB = () => (
  <a
    href={`${WHATSAPP_BASE}?text=${encodeURIComponent("Hi Al Mubeen, I want to book a stay!")}`}
    target="_top"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl hover:scale-110 transition-transform pulse-ring"
    aria-label="Chat on WhatsApp"
  >
    <i className="fa-brands fa-whatsapp text-3xl"></i>
  </a>
);

// ------------------- Active section observer -------------------
function useActiveSection() {
  const [active, setActive] = useState("home");
  useEffect(() => {
    const ids = NAV.map((n) => n.id);
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -50% 0px", threshold: 0 }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
    // NAV is module-level; setActive is stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return active;
}

function App() {
  const active = useActiveSection();

  // Health check (non-blocking)
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
    // API and axios are module-level constants
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <Nav active={active} />
      <Hero />
      <Marquee />
      <About />
      <Rooms />
      <Tours />
      <Gallery />
      <Reviews />
      <Contact />
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}

 export default App;

 
 
